import { CompoundButton, Icon } from '@fluentui/react';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EtaUser, Label, Section, SectionSize } from '@eta/components';
import { connect, ConnectedProps } from 'react-redux';
import DOMPurify from 'dompurify';
import { NavLink, Redirect } from 'react-router-dom';
import UserLayoutContent from '../common/layoutContent/UserLayoutContent';
import { TaxpayerSelfRegistryMain } from './TaxpayerSelfRegistryMain';
import { SuccessRegister } from './SuccessRegister';
import { ServiceCreator } from '../ContentManagement/Service/client';
import { ReduxState } from '../common/reducers';
import { MarkDownType } from '../common/config/constants';
import { authService } from '../Security/Security';
import './SignUp.scss';

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const SignUp: FC<PropsFromRedux> = (props: PropsFromRedux) => {
    const { t } = useTranslation(['SignUp']);
    const { currentLanguage } = props;
    const [startRegistry, setStartRegistry] = useState<boolean>(false);
    const [rin, setRin] = useState<string>();
    const [primaryName, setPrimaryName] = useState<string>();
    const [secondaryName, setSecondaryName] = useState<string>();
    const [email, setEmail] = useState<string>();
    const [contentIsland, setContentIsland] = useState<string>();
    const [currentUser, setCurrentUser] = useState<EtaUser>();
    const [errorr, setErrorr] = useState<string>();
    authService.onCurrentUserLoaded = (user: EtaUser) => {
        setCurrentUser(user);
    };

    const isSupportedOS = () => {
        if (window.navigator.appVersion.indexOf('Win') !== -1) return true;
        return false;
    };

    const onClick = () => {
        if (isSupportedOS()) setStartRegistry(true);
        else setErrorr(t('OSNotSupported'));
    };

    const handleMessageBarData = async (code: string) => {
        try {
            const isArLang = currentLanguage.langIso4.includes('ar');
            const currLang = isArLang ? 'ar' : 'en';
            const client = ServiceCreator.getContentManagementClient(true);
            const response = await client.getContentByCode(code, currLang);
            const content = isArLang
                ? response.contentSecondaryLang
                : response.contentPrimaryLang;
            setContentIsland(DOMPurify.sanitize(content ?? ''));
        } catch (exception) {
            setContentIsland(DOMPurify.sanitize(exception.message ?? ''));
        }
    };

    useEffect(() => {
        if(!currentUser)
        handleMessageBarData(MarkDownType.SelfRegisterConditions);
    }, [t]);

    if (!currentUser) {
        return (
            <UserLayoutContent>
                {rin ? (
                    <SuccessRegister
                        hidden={!rin}
                        rin={rin}
                        primaryName={primaryName}
                        secondaryName={secondaryName}
                        email={email}
                    />
                ) : (
                    <div id="SignUpMain">
                        {startRegistry ? (
                            <div>
                                <TaxpayerSelfRegistryMain
                                    onClose={() => {
                                        setStartRegistry(false);
                                    }}
                                    onSuccessRegister={(
                                        rinNumber,
                                        pName,
                                        sName,
                                        emailValue
                                    ) => {
                                        setRin(rinNumber);
                                        setPrimaryName(pName);
                                        setSecondaryName(sName);
                                        setEmail(emailValue);
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="Self-Register">
                                <div className="header">
                                    <p>{t('SelfRegister')}</p>
                                </div>
                                <div className="bodyLine">
                                    <div className="mainSignUpContent">
                                        <div className="ProcessTime">
                                            <Icon iconName="Recent" />
                                            <Label className="label">
                                                {t('ProcessTime')}
                                            </Label>
                                        </div>
                                        <Section
                                            size={SectionSize.h3}
                                            title={t('WhatYouNeed')}
                                        />
                                        <br />
                                        <div className="contentMain">
                                            <div
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        contentIsland ?? ''
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <br />
                                    </div>
                                    <div className="mainSignUpAction">
                                        <div className="parentRight">
                                        <CompoundButton
                                            className="StartRegistration"
                                            primary
                                            secondaryText={t('WindowsOnly')}
                                            onClick={() => onClick()}
                                        >
                                            <div className="contentBtn">
                                                <Icon iconName="NavigateExternalInline" />
                                                <span>
                                                    {t('StartRegistration')}
                                                </span>
                                            </div>
                                        </CompoundButton>
                                       
                                        {errorr && (
                                            <div className="ErrorrMsg"> 
                                                {`${errorr} ‘`}
                                                <NavLink
                                                    exact
                                                    to=""
                                                    target="_blank"
                                                >
                                                    {t('SupportedDevice')}
                                                </NavLink>
                                                {` ’.`}
                                            </div>
                                        )}
                                         </div>
                                    </div>
                                    <div className="Alternatively">
                                        <Section
                                            size={SectionSize.h3}
                                            title={t('Alternatively')}
                                        />
                                        <p>{t('VisitETAoffices')}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </UserLayoutContent>
        );
    }
    return <Redirect to="/home" />;
};
export default connector(SignUp);
